 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"attendance-apply-audit":"attendance-apply-audit","attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","hr-company-auth":"hr-company-auth","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-apply-audit":"71cf6706","attendance-clock-record":"ee38462d","attendance-clock-stats~shift-manage":"12c1304f","attendance-clock-stats":"4cf10064","shift-manage":"3e8d243d","autidt-list":"10394940","carousel-list~link-list~menu-list~permissions-list":"5cc025de","menu-list":"77a8d726","permissions-list":"edadce28","chunk-05dd824a":"d8bbde8e","chunk-28a34f7e":"6d0628fc","chunk-2d216257":"160fc50d","chunk-0ed724e6":"6f409b4f","chunk-2e0f34bd":"4a142cc3","chunk-73be8d41":"aa7b6af2","position-list":"aa8f8799","individual-list":"68a8570c","user-list":"52e29d51","chunk-283bc9b2":"8fe2d1c7","hr-company-auth":"cfdeef0e","chunk-3108329c":"267bb9e9","chunk-325098ac":"4f250e7d","chunk-59f10238":"01388da8","chunk-6337fcfc":"90794efc","ad-position-list":"12202a18","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"f51ad92d","article-edit":"3bd4f705","company-edit":"cc5eb638","openapiServer-edit":"2c4e2446","settlement-edit":"d55214cf","article-list":"85e1c594","attachment-list":"28fad79b","autidt-bill~autidt-contract~autidt-view~daily-settlement":"66eca13e","autidt-view":"be5ce40f","carousel-list":"e5986764","link-list":"16f9aae0","company-list":"c954fee4","lecturer-list":"1ffd5817","autidt-bill":"acaac3f9","autidt-contract":"65b54c22","daily-settlement":"b986f3d2","chunk-4e000596":"54404d3e","chunk-6e83591c":"163e5349","chunk-34182fda":"ea39283e","article-create":"e4c27261","bill-list":"d127a9fa","common-list":"f4406fa1","customer-list":"2c0a4e17","roles-list":"3aca4398","task-list":"79ba8431","openapiServer-list":"5b406f9f","settlement-list":"cec604aa","sys_log-list~withdraw-list":"c1f1cf49","sys_log-list":"d458477e","withdraw-list":"e1f4cfec","tax-list":"c3c05033","ws_account":"5ecf3edf","chunk-c442ea18":"9e0b23b3","category-list":"ee4315b9","live-list":"4cd32ddc","setting-site":"f0d73268","bill-edit":"a23fa516","customer-view":"934a343b","chunk-392798fa":"ea5c585d","chunk-3d61bb78":"9d6904e4","individual-view":"1e60b5c1","manage-members":"0e0f360c","chunk-a84f2b96":"0db4b345","chunk-03f16c3e":"b8cad30c","chunk-2b3e2cfe":"b1e76244","chunk-1c8840f0":"db233826","chunk-ccbb65ca":"c007b4e4","chunk-cddeed28":"3631d0db","chunk-37930f86":"51e9b705","chunk-6c56cea0":"f302d590","chunk-fdf9545a":"b10fef28","everyday_statistics":"b6a4c55f","exception-404":"4b7eeaed","login":"883a7ba1","new_hr":"b6cfc429","setting-base":"bdc7ee7f","statistics-flow~statistics-region":"c6494b83","statistics-flow":"8c4d618c","statistics-region":"cc9d08de","statistics-list":"4af4ce1c","token-login":"65237350","chunk-2f1214f0":"e85d0b94","chunk-26b166c4":"4141ced5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"attendance-apply-audit":1,"attendance-clock-record":1,"attendance-clock-stats~shift-manage":1,"attendance-clock-stats":1,"shift-manage":1,"autidt-list":1,"carousel-list~link-list~menu-list~permissions-list":1,"menu-list":1,"permissions-list":1,"chunk-05dd824a":1,"chunk-28a34f7e":1,"chunk-0ed724e6":1,"chunk-2e0f34bd":1,"position-list":1,"individual-list":1,"user-list":1,"hr-company-auth":1,"chunk-3108329c":1,"chunk-325098ac":1,"chunk-59f10238":1,"ad-position-list":1,"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":1,"article-edit":1,"company-edit":1,"openapiServer-edit":1,"settlement-edit":1,"article-list":1,"attachment-list":1,"autidt-bill~autidt-contract~autidt-view~daily-settlement":1,"autidt-view":1,"carousel-list":1,"link-list":1,"company-list":1,"lecturer-list":1,"autidt-bill":1,"autidt-contract":1,"daily-settlement":1,"chunk-4e000596":1,"article-create":1,"bill-list":1,"common-list":1,"customer-list":1,"roles-list":1,"task-list":1,"openapiServer-list":1,"settlement-list":1,"sys_log-list~withdraw-list":1,"sys_log-list":1,"withdraw-list":1,"tax-list":1,"ws_account":1,"chunk-c442ea18":1,"category-list":1,"live-list":1,"setting-site":1,"bill-edit":1,"customer-view":1,"chunk-392798fa":1,"chunk-3d61bb78":1,"individual-view":1,"manage-members":1,"chunk-a84f2b96":1,"chunk-03f16c3e":1,"chunk-2b3e2cfe":1,"chunk-1c8840f0":1,"chunk-ccbb65ca":1,"chunk-cddeed28":1,"chunk-37930f86":1,"chunk-6c56cea0":1,"chunk-fdf9545a":1,"everyday_statistics":1,"exception-404":1,"login":1,"new_hr":1,"setting-base":1,"statistics-flow":1,"statistics-region":1,"statistics-list":1,"token-login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"attendance-apply-audit":"attendance-apply-audit","attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","hr-company-auth":"hr-company-auth","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-apply-audit":"898b05c0","attendance-clock-record":"2b73f04f","attendance-clock-stats~shift-manage":"6fdfe8be","attendance-clock-stats":"e309b56e","shift-manage":"0c352d1c","autidt-list":"f1cf9de3","carousel-list~link-list~menu-list~permissions-list":"f1cf9de3","menu-list":"8bc0eb7c","permissions-list":"b9c9ddca","chunk-05dd824a":"41f49f96","chunk-28a34f7e":"bfa3c16c","chunk-2d216257":"31d6cfe0","chunk-0ed724e6":"01c9d44d","chunk-2e0f34bd":"151fb899","chunk-73be8d41":"31d6cfe0","position-list":"8c8b504f","individual-list":"ca7875e5","user-list":"0fbd0d20","chunk-283bc9b2":"31d6cfe0","hr-company-auth":"fed41780","chunk-3108329c":"f487520e","chunk-325098ac":"f47a419e","chunk-59f10238":"a1e9056b","chunk-6337fcfc":"31d6cfe0","ad-position-list":"6c15f24d","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"fcca00d1","article-edit":"81c2326f","company-edit":"6a772072","openapiServer-edit":"372bfbde","settlement-edit":"9f445d30","article-list":"fc157c4b","attachment-list":"14bd5e7b","autidt-bill~autidt-contract~autidt-view~daily-settlement":"befd2898","autidt-view":"a7887fef","carousel-list":"5332e5a6","link-list":"bf53ea62","company-list":"627a6dd3","lecturer-list":"886cab67","autidt-bill":"5f186058","autidt-contract":"f15e237e","daily-settlement":"7956c6ec","chunk-4e000596":"f3579bd2","chunk-6e83591c":"31d6cfe0","chunk-34182fda":"31d6cfe0","article-create":"20503b26","bill-list":"bacca06c","common-list":"18a54ca1","customer-list":"6fab0afe","roles-list":"e30af8ba","task-list":"9e4bb863","openapiServer-list":"ff12898c","settlement-list":"a1529f2c","sys_log-list~withdraw-list":"2513fa6f","sys_log-list":"a823e037","withdraw-list":"c2e02f20","tax-list":"ad4ccbf6","ws_account":"98eb842a","chunk-c442ea18":"db5c6c4e","category-list":"65c3310f","live-list":"a512e19f","setting-site":"edb73df0","bill-edit":"127772d2","customer-view":"c5a55abb","chunk-392798fa":"92464486","chunk-3d61bb78":"d8de3c75","individual-view":"6f914dec","manage-members":"14704666","chunk-a84f2b96":"ad0f9d12","chunk-03f16c3e":"5a428ef3","chunk-2b3e2cfe":"2a50113c","chunk-1c8840f0":"44798df4","chunk-ccbb65ca":"df2f2f8d","chunk-cddeed28":"cb9d1249","chunk-37930f86":"60921343","chunk-6c56cea0":"b524b5be","chunk-fdf9545a":"614c7561","everyday_statistics":"508ea32f","exception-404":"604eae9b","login":"57d1f132","new_hr":"3434eff9","setting-base":"f1cf9de3","statistics-flow~statistics-region":"31d6cfe0","statistics-flow":"40a66952","statistics-region":"112f20a9","statistics-list":"f1cf9de3","token-login":"c3de5933","chunk-2f1214f0":"31d6cfe0","chunk-26b166c4":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
